import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    button: 'w-7 flex center bg-grey-80 duration',
    container: 'h-6 b b-grey-70 rounded-md i-flex',
    display: 'w-10 flex center b-x b-grey-70 subtitle-4 duration'
  },
  iconSize: 'sm'
} satisfies VfConfig['stepper']
